module.exports = __webpack_public_path__ + "img/banco-de-brasilia.e13809ec.svg";